<template>
  <div :class="['text-cutter-wrapper', expanded ? 'expanded' : 'no-expand', wrapperClass, {'no-readmore-btn': !disableMoreButton}]">
    <div ref="el" class="text mb-3" :class="{ 'expanded': expanded }" :style="lineClampStyle">
      <slot/>
    </div>
    <div v-if="disableMoreButton" class="button-wrapper text-center justify-center flex items-center">
      <button class="read-more-btn justify-center flex items-center" @click="toggleExpanded">
        <Icon
          wrapper-class="arrow-icon"
          name="solid_arrow_down"
          width="16px"
          height="10px"
          color="#E60021"
          viewBox="0 0 16 10"
            />
        <span class="btn-text">{{ expanded ? '折りたたむ' : 'もっと見る' }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextHeightCutter',
  props: {
    disableMoreButton: {
      type: Boolean,
      default: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    height: {
      type: Number,
      required: true,
    },
    wrapperClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      expanded: this.isExpanded,
      customHeight: this.height
    };
  },
  computed: {
    lineClampStyle() {
      if (this.expanded) {
        return {
          '-webkit-line-clamp': 'unset',
          '-webkit-box-orient': 'unset',
          overflow: 'visible',
          display: 'block',
        };
      } else {
        return {
          '-webkit-line-clamp': 'unset',
          '-webkit-box-orient': 'unset',
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          display: '-webkit-box',
          'height': `${this.customHeight}px`,
          '-webkit-box-decorator-break': 'clone',
        };
      }
    }
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
  watch: {
    expanded(newVal) {
      this.$emit('update:isExpanded', newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.expanded {
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  display: block;
  .button-wrapper {
    .read-more-btn {
      .arrow-icon {
        transform: rotate(180deg);
      }
    }
  }
}
.no-expand {
  .text {
    transition: all 0.4s ease;
    position: relative;
    &:before {
      content: '';
      display: block;
      background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff 90%);
      width: 100%;
      height: 38px;
      bottom: 0;
      position: absolute;      
    }
  }
  &.no-readmore-btn {
    .text {
      height: auto !important;
      &:before {
        display: none;
      }
    }
  }
}

.read-more-button {
  margin-top: 10px;
}
@import "./styles.scss";
</style>
